import React, { PureComponent } from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import {
  Label,
  Input,
} from 'reactstrap';

import HelpIcon from '../HelpIcon';
import UpgradePlanButton from '../UpgradePlanButton';

import ShareModalFileSizes from './ModalFileSizes';
import { userHasFeature } from '../../helpers/Features';
import { canUserManageShare } from '../../helpers/Share';

class ShareModalSelectFileSizes extends PureComponent {
  render() {
    const {
      intl,
      selectFileSizes,
      handleChange,
      handleFileSizesChange,
      fileSizes,
      allowDownload,
    } = this.props;

    return (
      <div className="share-select-file-sizes share-setting">
        <Label for="inpSelectFileSizes" className={classnames('switch', { disabled: !allowDownload || !canUserManageShare() })}>
          <span>
            {intl.formatMessage({ defaultMessage: 'File sizes' })}
            <HelpIcon id="share-select-file-sizes">
              {intl.formatMessage({ defaultMessage: 'Restrict what file sizes are available to download in this share link.' })}
            </HelpIcon>
          </span>
          <div className="share-setting-switch-wrapper">
            <UpgradePlanButton feature="share-file-sizes" simple={true} />
            {!allowDownload && (
              <HelpIcon id="share-allow-comments-disabled" permanent={true}>
                {intl.formatMessage({ defaultMessage: 'Enable downloading to select file sizes' })}
              </HelpIcon>
            )}
            {userHasFeature('share-file-sizes') && (
              <div className="switch-control input-inner">
                <Input
                  type="checkbox"
                  name="select-file-sizes"
                  id="inpSelectFileSizes"
                  value={true}
                  checked={selectFileSizes}
                  onChange={handleChange}
                  disabled={!allowDownload || !canUserManageShare()}
                />
                <i />
              </div>
            )}
          </div>
        </Label>

        {selectFileSizes && (
          <ShareModalFileSizes
            {...this.state}
            handleChange={handleFileSizesChange}
            fileSizes={fileSizes}
          />
        )}
      </div>
    );
  }
}

ShareModalSelectFileSizes.propTypes = {
  intl: PropTypes.object.isRequired,
  allowDownload: PropTypes.bool.isRequired,
  selectFileSizes: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleFileSizesChange: PropTypes.func.isRequired,
  fileSizes: PropTypes.array.isRequired,
};

export default injectIntl(ShareModalSelectFileSizes);
